/**
 * OnboardingCard — selectable option card for onboarding flows.
 *
 * Props:
 *   title      string    — Card heading (Fraunces SemiBold 24px)
 *   description string   — Card body text (Nunito SemiBold 16px, muted)
 *   selected   bool      — Whether this card is currently selected
 *   onClick    fn        — Selection handler
 *   badge      string?   — Optional pill badge text (e.g. "Recommended for most families")
 *   meta       node?     — Optional supplementary content rendered after the description (e.g. a range hint).
 */
import s from './OnboardingCard.module.css';

export default function OnboardingCard({ title, description, selected, onClick, badge, meta }) {
  return (
    <button
      type="button"
      role="radio"
      aria-checked={selected}
      onClick={onClick}
      className={`${s.card} ${selected ? s.cardSelected : ''}`}
    >
      {badge && <span className={s.badge}>{badge}</span>}
      <span className={s.title}>{title}</span>
      <span className={s.description}>{description}</span>
      {meta}
    </button>
  );
}
